import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { productOptions } from "../formData";

const ProductSelect = ({ value, error, helperText, onChange, onBlur }) => {
  return (
    <Autocomplete
      id="product"
      options={productOptions}
      getOptionLabel={(option) => option.label}
      value={productOptions.find((opt) => opt.value === value) || null}
      onChange={(_, newValue) => {
        onChange({
          target: {
            name: "product",
            value: newValue ? newValue.value : "",
          },
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Product"
          variant="outlined"
          name="product"
          error={error}
          helperText={helperText}
          size="medium"
          onBlur={onBlur}
          autoComplete="off"
        />
      )}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      fullWidth
      clearOnEscape
    />
  );
};

export default ProductSelect;
